import { API_BASE_URL, ACCESS_TOKEN } from '../constants';
import * as axios from "axios";
import {paymentStatusType} from "./Helpers";
import moment from "moment";

const request = (options) => {
    const headers = {};
    if(options.isDownload){
        headers['responseType'] = 'arraybuffer';
        delete options.isDownload;
    }
    headers['Content-Type'] = 'application/json;charset=UTF-8';
    if(localStorage.getItem(ACCESS_TOKEN)) {
        headers['Authorization'] = 'Bearer ' + localStorage.getItem(ACCESS_TOKEN);
    }

    const defaults = {headers: headers};
    options = Object.assign({}, defaults, options);
    return axios(options);
};

export function fetchRequest(requestData,url,cancelToken) {
    return request({
        url: API_BASE_URL + url,
        method: 'POST',
        cancelToken: cancelToken,
        data: requestData
    });
}

export function getRequest(url,cancelToken) {
    return request({
        url: API_BASE_URL + url,
        method: 'GET',
        cancelToken: cancelToken,
    });
}

export function downloadRequest(requestData,url,cancelToken){
    return request({
        url: API_BASE_URL + url,
        method: 'POST',
        cancelToken: cancelToken,
        data: requestData,
        isDownload: true
    });
}

export function login(loginRequest) {
    return request({
        url: API_BASE_URL + "/auth/get-token",
        method: 'POST',
        data: loginRequest
    });
}

export function processPayment(type,paymentInfo) {
    let url ="/external/process-payment"
    return request({
        url: API_BASE_URL + url,
        method: 'POST',
        data: paymentInfo
    });
}

export function checkPayment(type,uuid,transactionType,paymentStatus) {
    let url ="/external/check-payment/"
    return request({
        url: API_BASE_URL + url + uuid +"?transactionType="+transactionType+'&paymentStatus='+paymentStatus,
        method: 'GET'
    });
}

export function hizlitahsilat(dto) {
    let url ="/external/hizlitahsilat/"
    return request({
        url: API_BASE_URL + url,
        method: 'POST',
        data:dto
    });
}

export function getPos(cardNo,referenceId) {
    let url ="/external/getPos/"
    return request({
        url: API_BASE_URL + url + cardNo +"/"+referenceId,
        method: 'GET'
    });
}

export function getCurrency(currencyType) {
    let url ="/external/currency/"
    return request({
        url: API_BASE_URL + url + currencyType,
        method: 'GET'
    });
}

export function getCurrentUser() {
    if(!localStorage.getItem(ACCESS_TOKEN)) {
        return Promise.reject("No access token set.");
    }

    return request({
        url: API_BASE_URL + "/auth/me",
        method: 'GET'
    });
}

export function getUserProfile(username) {
    return request({
        url: API_BASE_URL + "/auth/" + username,
        method: 'GET'
    });
}

export function getCurrencyCodes() {
    let url ="/payment/getDataInfo"
    return request({
        url: API_BASE_URL + url,
        method: 'GET'
    });
}

export function statistics() {
    let url ="/token/statistics"
    return request({
        url: API_BASE_URL + url,
        method: 'GET'
    });
}

export function getPaymentCount(statusType=paymentStatusType.SUCCESS, currencyCode = "TRY",start,end, appName) {
    let url ="/payment/getPaymentCount"
    return request({
        url: API_BASE_URL + url,
        method: 'POST',
        data:{
            statusType,
            currencyCode,
            appName,
            start:moment(start,"DD-MM-YYYY").format("YYYY-MM-DD"),
            end:moment(end,"DD-MM-YYYY").format("YYYY-MM-DD")
        }
    });
}

export function getPaymentAmount(statusType=paymentStatusType.SUCCESS, currencyCode = "TRY",start,end, appName) {
    let url ="/payment/getSumPaymentAmount"
    return request({
        url: API_BASE_URL + url,
        method: 'POST',
        data:{
            statusType,
            currencyCode,
            appName,
            start:moment(start,"DD-MM-YYYY").format("YYYY-MM-DD"),
            end:moment(end,"DD-MM-YYYY").format("YYYY-MM-DD")
        }
    });
}

export function getPieChartData(start, end, currencyCode) {
    let url = "/payment/getPieChartData"
    return request({
        url: API_BASE_URL + url,
        method: 'POST',
        data: {
            currencyCode,
            start:moment(start,"DD-MM-YYYY").format("YYYY-MM-DD"),
            end:moment(end,"DD-MM-YYYY").format("YYYY-MM-DD")
        }
    });
}

export function getLineChartData(start, end, currencyCode) {
    let url = "/payment/getLineChartData"
    return request({
        url: API_BASE_URL + url,
        method: 'post',
        data: {
            currencyCode,
            start:moment(start,"DD-MM-YYYY").format("YYYY-MM-DD"),
            end:moment(end,"DD-MM-YYYY").format("YYYY-MM-DD")
        }
    });
}


// WEBPACK FOOTER //
// ./src/util/APIUtils.js